import { GridColDef } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { ExtendedGridColDef } from '@Types/ExtendedGridColDef';
import { ICulture } from '@Types/Translation';

export const cultureColumns: (GridColDef<ICulture> & ExtendedGridColDef)[] = [
  {
    field: 'cultureCode',
    headerName: 'Culture Code',
    hideable: false,
    flex: 0.25,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{params.value}</span>
            {params.row.isBaseline ? (
              <Chip
                color='secondary'
                label='Baseline'
                size='small'
                sx={{ height: 20, fontSize: 11 }}
              />
            ) : null}
          </Box>
        </Tooltip>
      );
    },
  },
  {
    field: 'displayName',
    headerName: 'Language',
    hideable: false,
    flex: 0.3,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span className='table-cell-truncate'>{params.value}</span>
        </Tooltip>
      );
    },
  },
  {
    field: 'translationCount',
    headerName: 'Keys',
    hideable: false,
    flex: 0.15,
  },
  {
    field: 'isActive',
    headerName: 'Active',
    hideable: false,
    flex: 0.15,
    valueGetter: (params) => (params.row.isActive ? 'Yes' : 'No'),
  },
];
